import { useEffect, useRef, useState } from 'react';

export const useIdleTimer = ({ timeout = 1200, warningTime = 1080, onTimeout, onWarning }) => {
    const [isWarningShown, setWarningShown] = useState(false);
    const [countdown, setCountdown] = useState(0);

    const idleTimerRef = useRef(null);
    const countdownIntervalRef = useRef(null);

    const startIdleTimer = () => {
        clearTimeout(idleTimerRef.current);
        idleTimerRef.current = setTimeout(() => {
            setWarningShown(true);
            const initialCountdown = timeout - warningTime;
            setCountdown(initialCountdown);
            if (onWarning) onWarning();
        }, warningTime * 1000);
    };

    const resetAllTimers = () => {
        clearTimeout(idleTimerRef.current);
        clearInterval(countdownIntervalRef.current);
        setWarningShown(false);
        setCountdown(0);
        startIdleTimer();
    };

    useEffect(() => {
        const handleActivity = () => {
            if (!isWarningShown) {
                resetAllTimers();
            }
        };

        const events = ['mousemove', 'keydown', 'scroll', 'click'];
        events.forEach((event) => window.addEventListener(event, handleActivity));
        startIdleTimer();

        return () => {
            events.forEach((event) => window.removeEventListener(event, handleActivity));
            clearTimeout(idleTimerRef.current);
            clearInterval(countdownIntervalRef.current);
        };
    }, [isWarningShown]);

    useEffect(() => {
        if (isWarningShown && countdown > 0) {
            countdownIntervalRef.current = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdownIntervalRef.current);
                        if (onTimeout) onTimeout();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(countdownIntervalRef.current);
    }, [isWarningShown]);

    const resetTimer = () => {
        resetAllTimers();
    };

    return { isWarningShown, countdown, resetTimer };
};
